exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3hFeNV4KMWMtUhcbjYn1ON{margin-top:10px;margin-bottom:10px}._13qHFNa2oUNZlKPVY1_thA{margin-right:10px}\n", ""]);

// Exports
exports.locals = {
	"form": "_3hFeNV4KMWMtUhcbjYn1ON",
	"checkbox": "_13qHFNa2oUNZlKPVY1_thA"
};